import $ from 'jquery'
import _ from 'lodash'
import './ckeditor/ckeditor.js'
import './bootstrap-ckeditor-fix'

CKEDITOR.on('dialogDefinition', function (e) {
  e.data.definition.resizable = CKEDITOR.DIALOG_RESIZE_NONE
});

var getHeight = function (ta) {
  var hidden = !ta.is(':visible')
  if (hidden) {
    ta.show()
  }
  var height = ta.height()
  if (hidden) {
    ta.hide()
  }
  return height
}

var pluginsLoadedHandler = function (e) {
  e.editor.dataProcessor.dataFilter.addRules({
    elements: {
      a: function (element) {
        element.attributes.target = '_blank'
        element.attributes.rel = 'noopener noreferrer'
      },
    },
  })
  e.editor.dataProcessor.htmlFilter.addRules({
    elements: {
      a: function (element) {
        element.attributes.target = '_blank';
        element.attributes.rel = 'noopener noreferrer'
      },
    },
  })
}

var instanceReadyHandler = function (textarea, initFinCallback) {
  return function (e) {
    $(textarea).data('ckeditor', e.editor)

    // Output paragraphs as <p>Text</p>.
    e.editor.dataProcessor.writer.lineBreakChars = ''
    _(['p', 'h1', 'h2', 'h3', 'table', 'thead', 'tfoot',
      'tr', 'th', 'td', 'div', 'u', 'ul', 'li', 'ol',
    ]).each(function (tag) {
      e.editor.dataProcessor.writer.setRules(tag, {
        indent: false,
        breakBeforeOpen: false,
        breakAfterOpen: false,
        breakBeforeClose: false,
        breakAfterClose: false,
      })
    })
    e.editor.fire('change')
    e.editor.updateElement()
    if (typeof initFinCallback == 'function') {
      initFinCallback(textarea)
    }
  }
}

var getCfg = function (textarea, ctx, lang, enables, custom, initFinCallback) {
  var config = _.merge({
    customConfig: '', // Do not use external config.js file
    contentsCss: ctx + '/css/ckeditor.css',
    height: getHeight(textarea),
    fillEmptyBlocks: false,
    toolbarGroups: [
      { name: 'basicstyles', groups: ['basicstyles'] },
      { name: 'styles' },
      { name: 'paragraph',   groups: ['list', 'indent'] },
      { name: 'links' },
      { name: 'insert' },
      { name: 'clipboard',   groups: ['clipboard'] },
    ],
    removeButtons: 'Cut,Copy,Paste,PasteText,PasteFromWord,Anchor,Strike,Subscript,' +
    'Superscript,Outdent,Indent',
    allowedContent: 'p;h1;h2;h3;a[!href,target,rel];strong;em;u;ul;li;ol;' +
    (enables.img === true ? 'img[alt,altid,!src];' : '') +
    (enables.table === true ? 'table;tbody;thead;tfoot;tr;th[scope];td;' : '') +
    (enables.pagebreak === true ? 'div{page-break-after};span{display};' : ''),
    format_tags: 'p;h1;h2;h3',
    removePlugins: (enables.pagebreak === false ? 'pagebreak' : ''),
    extraPlugins: (enables.table ? 'table' : ''),
    linkShowAdvancedTab: false,
    linkShowTargetTab: false,
    wordcount: {
      showParagraphs: false, // Whether or not you want to show the Paragraphs Count
      showWordCount: false, // Whether or not you want to show the Word Count
      showCharCount: true, // Whether or not you want to show the Char Count
      countSpacesAsChars: true, // Whether or not you want to count Spaces as Chars
      countLineBreaks: false, // Whether or not to include Line Breaks in the Char Count
      countBytesAsChars: true,
      countHTML: true, // Whether or not to include Html chars in the Char Count
      maxWordCount: -1, // Maximum allowed Word Count, -1 is default for unlimited
      maxCharCount: -1, // Maximum allowed Char Count, -1 is default for unlimited
    },
    language: lang,
    uiColor: '#FFFFFF',
    on: {
      pluginsLoaded: pluginsLoadedHandler,
      instanceReady: instanceReadyHandler(textarea, initFinCallback),
    },
  }, custom)

  return config
}

export default {
  init: function (textarea, ctx, lang, custom, initFinCallback) {
    if (!CKEDITOR.env.isCompatible) {
      console.log('Editor::CKEDITOR not supported in this platform')
      return null
    }
    _([textarea, ctx, lang]).each(function (e, k) {
      if (e === undefined || e === null) {
        console.log('Editor::init missing parameter ' + k + ' must be set')
      }
    })
    var enables = {
      default: $(textarea).hasClass('sntz-default'),
      pagebreak: $(textarea).hasClass('sntz-pagebreak'),
      img: $(textarea).hasClass('sntz-img'),
      table: $(textarea).hasClass('sntz-table'),
    }
    var edit = CKEDITOR.replace(textarea, getCfg($(textarea), ctx, lang,
      enables, custom, initFinCallback))
    var text = $(textarea).val()
    text = text.replace(/\/img\/edit\/..\//g, '/img/edit/' + lang + '/');
    $(textarea).val(text)
    edit.on('blur', function (e) {
      e.editor.updateElement()
      $(textarea).trigger('blur')
    })
    return edit
  },
}
